import axios from "axios";

// The built UI is served by the backend jar itself (copied into src/main/resources/public), so in a
// production bundle the API is always on the same origin. A relative base URL therefore works on any
// hostname or IP the box is reached by (our new EC2 hosts by Elastic IP until DNS moves, the clippn
// hostnames, nginx in front) and never triggers CORS. The absolute URL from .env.development is only
// needed by `npm start`, where the UI runs on :3000 and the API on :8080.
// REACT_APP_API_BASE_URL_OVERRIDE forces an absolute base in a build should the UI ever be hosted apart.
const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL_OVERRIDE || ""
    : process.env.REACT_APP_API_BASE_URL;

export default axios.create({
  baseURL,
});
